export default "__VITE_ASSET__D_au0eML__"